import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { RecoilState, useRecoilState } from "recoil";
import useLocationQuery from "../../hooks/use-location-query";
import Card from "../Card";
import { TabItem } from "./LyfeTabs";
import TabHeaderComponent from "./TabHeaderComponent";
import TabPanel from "./TabPanel";

interface IProps {
	tabState: RecoilState<number>;
	activeTabProp?: number;
	noCardWrap?: boolean;
	useUrlTab?: boolean; //flags if we want to manage active tabs via url query param 'tab'
	bottomMargin?: number;
	onTabClick?: (tab: number) => void;
	tabs: Array<TabItem>;
	flex?: boolean;
}

const TabComponent = (props: { tab: TabItem; isActive: boolean; flex?: boolean }) => {
	const [wasActivated, setWasActivated] = useState(false);
	useEffect(() => {
		if (props.isActive) {
			setWasActivated(true);
		}
	}, [props.isActive]);

	return (
		<Box hidden={!props.isActive} width="100%" style={props.flex ? { display: "flex", flexDirection: "column", flexGrow: 1 } : {}}>
			{(props.isActive || wasActivated) && <TabPanel>{props.tab.component}</TabPanel>}
		</Box>
	);
};

const TabsComponent = (props: IProps) => {
	const query = useLocationQuery();
	const location = useLocation();
	const [activeTab, setActiveTab] = useRecoilState(props.tabState);
	const { replace } = useHistory();
	const urlTab = query.get("tab");

	function setTabInUrl(newTabValue: number): string {
		const searchHasTab = window.location.search.includes("&tab=");
		if (searchHasTab && props.useUrlTab) return window.location.search.replace(`&tab=${urlTab}`, `&tab=${newTabValue}`);
		if (!searchHasTab && props.useUrlTab) return window.location.search + `&tab=${newTabValue}`;
		return "";
	}

	useEffect(() => {
		//updates tab state based on URL tab
		if (urlTab) {
			urlTab && setActiveTab(+urlTab);
			replace(`${window.location.pathname}${setTabInUrl(urlTab ? +urlTab : activeTab)}${location.hash}`, location.state);
		}
		//only add tabs to url if this prop was explicitly passed
		props.useUrlTab &&
			replace(`${window.location.pathname}${setTabInUrl(urlTab ? +urlTab : activeTab)}${location.hash}`, location.state);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);

	return (
		<>
			{!props.noCardWrap ? (
				<Card>
					<TabHeaderComponent
						tabLabels={props.tabs.map((t) => t.label)}
						areTabsDisabled={props.tabs.map((t) => !!t.isTabDisabled)}
						tabState={props.tabState}
						setTabInUrl={setTabInUrl}
						onTabClick={props.onTabClick}
						tooltip={props.tabs.map((t) => t.tooltip)}
						TabIcon={props.tabs.map((t) => t.TabIcon)}
						propStyles={props.tabs.map((t) => t.propStyles)}
					></TabHeaderComponent>
				</Card>
			) : (
				<TabHeaderComponent
					tabLabels={props.tabs.map((t) => t.label)}
					areTabsDisabled={props.tabs.map((t) => !!t.isTabDisabled)}
					tabState={props.tabState}
					setTabInUrl={setTabInUrl}
					onTabClick={props.onTabClick}
					tooltip={props.tabs.map((t) => t.tooltip)}
					TabIcon={props.tabs.map((t) => t.TabIcon)}
					propStyles={props.tabs.map((t) => t.propStyles)}
				></TabHeaderComponent>
			)}
			{<TabComponent tab={props.tabs[activeTab || 0]} isActive={true} flex={props.flex} />}
		</>
	);
};

export default TabsComponent;
